module.exports = __webpack_public_path__ + "img/top-logo-fond-noir.5579221b.png";